export default __webpack_public_path__ + "static/media/gallery_03.df54f9d0.jpg";